import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  return (
    // <div className="footer pt-5 px-1 d-flex align-items-center text-muted justify-content-between">
    //   <p>HackFlix</p>
    //   <p>Soy un footer</p>
    //   <p>Triana Misa</p>
    // </div>
    !location.pathname.includes("/watch") && (
      <>
        <hr className="mt-5" />
        <footer className="d-flex flex-wrap justify-content-between align-items-center py-3  my-4 ">
          {/* <div className="icon-container d-md-none d-lg-block">
          <div className="fw-bold text-white fs-2 h-container px-3 py-1">H</div>
        </div> */}

          <ul className="nav  justify-content-end">
            <li className="nav-item">
              <Link
                to="/"
                className="nav-link Link px-2 text-muted"
                onClick={() => window.scrollTo(0, 0)}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/showall"
                className="nav-link Link px-2 text-muted"
                onClick={() => window.scrollTo(0, 0)}
              >
                All movies
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className="nav-link Link px-2 text-muted"
                onClick={() => window.scrollTo(0, 0)}
              >
                About us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-link Link px-2 text-muted"
                onClick={() => window.scrollTo(0, 0)}
              >
                Contact
              </Link>
            </li>
          </ul>
          <p className=" mb-0 px-2 text-muted">&copy; 2021 Company, Inc</p>
        </footer>
      </>
    )
  );
};
export default Footer;
